import type { DriveStep } from 'driver.js'

export const agentsTour: Array<DriveStep> = [
  {
    element: '#agents-header',
    popover: {
      title: 'What an agent is',
      description:
        'An agent is a <strong>coordinator</strong> model plus the <strong>specialists</strong> it can consult. The coordinator answers every request and brings in a specialist when the task calls for it — you call the whole team with a single request.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#agents-new-btn',
    popover: {
      title: 'Build one in a minute',
      description:
        'Pick a coordinator model, add the specialists you want, and decide how each one replies. No code — the canvas walks you through it.',
      side: 'bottom',
      align: 'end',
    },
  },
  {
    element: '#agents-list',
    popover: {
      title: 'Your agents',
      description:
        'Your agents live in this list. Each one shows its coordinator, the specialists it can call on, and when it last changed — and once you have a few, you can search them by name or Stack ID.',
      side: 'top',
    },
  },
  {
    element: '#agent-card-stack-id',
    popover: {
      title: 'Call it like any other model',
      description:
        'Click to copy the <strong>Stack ID</strong>, then send it as the <code>model</code> field in a normal chat completion request. Your existing OpenAI-compatible client needs no other change.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#agent-card-specialists',
    popover: {
      title: 'Advise or delegate',
      description:
        'Each specialist chip shows what happens to its answer. <strong>Advises</strong> — it reports back and the coordinator writes the final reply. <strong>Delegates</strong> — its answer is sent to the user exactly as written.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    popover: {
      title: "That's the whole idea",
      description:
        'Create an agent, copy its Stack ID, point your client at it. You can change the team or how each specialist replies at any time — callers keep using the same Stack ID.',
      showButtons: ['close'],
    },
  },
]
